import { useFormState, useWatch } from 'react-hook-form';
import type { ResourceListItemFront } from '../../../domain/domain/models/resources.model';
import { useEditResourceForm } from '../../hooks/useEditResourceForm.hook';
import { useCallback, useMemo } from 'react';
import { logError } from '@ingenico/util-common';
import { updateResourceItem } from './EditResourceModal.util';
import { isEqual } from 'lodash-es';
import { mapResourceToFormValues } from '../resources-list/ResourcesList.util';

export interface UseEditResourceModalVMParam {
  readonly resource?: ResourceListItemFront;
  readonly onConfirm?: (resource: ResourceListItemFront) => void;
}

export function useEditResourceModalVM({ resource, onConfirm }: UseEditResourceModalVMParam) {
  const defaultValues = useMemo(() => mapResourceToFormValues(resource), [resource]);
  const { form, reset } = useEditResourceForm(defaultValues);

  const formState = useFormState({ control: form.control });
  const formValues = useWatch({ control: form.control });

  const handleConfirm = useCallback(() => {
    form
      .handleSubmit((values) => onConfirm?.(updateResourceItem(values, resource)))()
      .then(() => void 0)
      .catch(logError);
  }, [form, onConfirm, resource]);

  const hasNoChanges = useMemo(() => isEqual(formValues, defaultValues), [formValues, defaultValues]);

  return {
    form,
    reset,
    isFormValid: formState.isValid,
    handleConfirm,
    hasNoChanges,
  };
}
